<template>
  <List :mapState="'papeleriaProductsCategories'" :allDispatch="'papeleriaProductsCategoriesAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/papeleria/products/categories/list.vue